import React from 'react';
import Modal, { usePreventDismissing } from '../../Components/Modal';
import Grid from '../../Components/Formatting/Grid';
import ButtonRow from '../../Components/Button/ButtonRow';
import Button from '../../Components/Button/Button';
import { useDialogues } from '../../Components/Dialogues';
import CopyableValue from '../../Components/Formatting/CopyableValue';

const PortalPin = ({isOpen, customer, changeSecurity, onClose}) => {
    return <Modal title="Portal PIN" isOpen={isOpen} setIsOpen={onClose} dismissible>
        {(isOpen && customer) && <Inner {...{customer, changeSecurity, onClose}} />}
    </Modal>
}

const Inner = ({customer, changeSecurity, onClose}) => {
    const {confirm, isDialogueOpen} = useDialogues();

    usePreventDismissing(isDialogueOpen);

    const doChange = () => {
        return confirm(
            {
                theme: 'danger',
                title: 'Change PIN?',
                message: <>
                    If you change the customer's PIN, they won't be able to log until they receive the new PIN.<br />
                    Any secure links they have been sent will also stop working.
                </>,
            },
            () => changeSecurity(customer.id)
        );
    }
    return <>
        <p className="my-4 prose-sm text-muted">
            The customer can use their ID, email address, or phone number to log into the customer portal, along with their pin.<br />
            You can also send them a secure link to log in without a PIN.
        </p>

        <Grid items={[
            [
                <strong>Customer Code</strong>,
                <CopyableValue value={customer.shortId} fontMono trackingWide />,
            ],
            [
                <strong>PIN</strong>,
                <CopyableValue value={customer.pin} fontMono trackingWide />,
            ]
        ]} />

        <ButtonRow arrange="between">
            <Button theme="danger" label="Change PIN" onClick={doChange} />
            <Button theme="secondary" label="Close" onClick={onClose} />
        </ButtonRow>
    </>
}

export default PortalPin;
